import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=7104a96e&scoped=true"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=7104a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104a96e",
  null
  
)

export default component.exports